import React from 'react';
import './Disclaimer.css';

const Disclaimer = () => {
  return (
    <section className="disclaimer-section">
      <div className="container">
        <h3 className="disclaimer-title">
          <svg className="disclaimer-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
            <path d="M12 8V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <circle cx="12" cy="16" r="1" fill="currentColor"/>
          </svg>
          IMPORTANT DISCLAIMER
        </h3>
        
        <div className="disclaimer-content">
          <div className="disclaimer-item">
            <h4>No Facilitation Fees:</h4>
            <p>We charge no facilitation fees. Visa and admission fees will be paid directly to the university. Student has to pay nothing upfront either to school or university except I-20 fees.</p>
          </div>
          
          <div className="disclaimer-item">
            <h4>Investment Figures:</h4>
            <p>All investment figures mentioned are approximate and may vary slightly. Actual costs depend on exchange rates, university fee revisions, and individual circumstances.</p>
          </div>
          
          <div className="disclaimer-item">
            <h4>Earnings Disclaimer:</h4>
            <p>Earning potential and timelines mentioned are indicative based on industry averages and past student experiences. Actual earnings depend on individual performance, market conditions, and employment opportunities.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Disclaimer;
